import React, { useState, useCallback } from 'react';
import debounce from 'lodash/debounce';
import { MdLocationOn } from 'react-icons/md';
import { getAddressDetails, searchAddress } from '../../api';
import InputField from './InputField';
import { extractAddressComponents } from '../../utils';

const AddressSearchField = ({
    label,
    value,
    onChange,
    placeholder,
    name,
    error,
    onChangeState,
    onChangeCity,
    onChangeZipcode
}) => {
    const [suggestions, setSuggestions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchAddresses = async (input) => {
        setIsLoading(true);
        try {
            const response = await searchAddress(input);
            console.log("🚀 ~ fetchAddresses ~ response:", response)
            if (response?.statusCode === 200) {
                setSuggestions(response?.body?.predictions);
            }
        } catch (error) {
            console.error('Error fetching addresses:', error);
            setSuggestions([]);
        } finally {
            setIsLoading(false);
        }
    };

    const debouncedFetch = useCallback(
        debounce((input) => {
            fetchAddresses(input);
        }, 300),
        []
    );

    const handleInputChange = (e) => {
        const input = e.target.value;
        onChange(e);
        debouncedFetch(input);
    };

    const handleSuggestionClick = async (suggestion) => {
        getAddressDetails(suggestion?.place_id).then(response => {
            const { city, state, zipcode, street, street_number } = extractAddressComponents(response);
            onChange({ target: { name, value: `${street_number ?? ''} ${street ?? ''}` } });
            onChangeState(state ?? '');
            onChangeCity(city ?? '');
            onChangeZipcode(zipcode ?? '');
            setSuggestions([]);
        });
    };

    return (
        <InputField
            label={label}
            value={value}
            onChange={handleInputChange}
            placeholder={placeholder}
            name={name}
            error={error}
            icon={MdLocationOn}
            isLoading={isLoading}
            suggestions={suggestions}
            onSuggestionClick={handleSuggestionClick}
        />
    );
};

export default AddressSearchField; 